export default __webpack_public_path__ + "favicon-32.png";